import { Commit, Module } from 'vuex';
import {
	RootState,
	JobState,
	JobListType,
	JobStatusesInListType,
	JobPageData,
	JobApplicationPageData,
	JobTimeslotPageData,
	PeriodConstraints,
} from '../types';
import { api } from '../../plugins/salut-api';
import {
	EmptyMultiLangText,
	Job,
	JobDto,
	JobSession,
	JobStatusCode,
	JobEditStep,
	JobTimeslot,
	JobApplication,
	ScheduleFrequency,
	TableItemsOptions,
	JobSessionType,
	JobTimeslotInstance,
	JobOfflineAttendanceChange,
	JobAttendance,
	JobApplicationDto,
	JobAttendanceImportTableItem,
	AttendanceImportMatchType,
	defaultTimeSlotFactory,
	BasicFieldType,
	JobApplicationCache,
} from '../../types';
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import { AuthGetterKeys } from './auth';
import { roundToNearestMinutes } from 'date-fns';
import { AlertActionKeys } from './alert';
import { i18n } from '../../lib';

//localStorage keys
const JOB_ATTENDANCE_FULL_LIST = 'job_attendance_full_list';
const JOB_GROUPED_OFFLINE_ATTENDANCE_CHANGES =
	'job_grouped_offline_attendance_changes';

const SET_SUBMIT_FROM = 'SET_SUBMIT_FROM';
const UNSET_SUBMIT_FROM = 'UNSET_SUBMIT_FROM';
const SHOW_SUBMITTING = 'SHOW_SUBMITTING';
const HIDE_SUBMITTING = 'HIDE_SUBMITTING';
const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';
const SET_LAST_ERROR = 'SET_LAST_ERROR';
const SET_JOBS = 'SET_JOBS';
const SET_EVENT_TYPES = 'SET_EVENT_TYPES';
const SET_LAST_JOB_LIST = 'SET_LAST_JOB_LIST';

const SET_CURRENT_JOB = 'SET_CURRENT_JOB';
const SET_CURRENT_CLONE_JOB = 'SET_CURRENT_CLONE_JOB';
const SET_CURRENT_JOB_VALIDATIONS = 'SET_CURRENT_JOB_VALIDATIONS';
const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
const SET_CURRENT_TIMESLOT = 'SET_CURRENT_TIMESLOT';
const SET_CURRENT_JOB_SESSION_BY_POSITION =
	'SET_CURRENT_JOB_SESSION_BY_POSITION';
const SET_CURRENT_JOB_SESSION_SCHEDULE_BY_POSITION =
	'SET_CURRENT_JOB_SESSION_SCHEDULE_BY_POSITION';
const SET_VOLUNTEER_FUNCTIONS = 'SET_VOLUNTEER_FUNCTIONS';
const SET_SESSION_TYPES = 'SET_SESSION_TYPES';
const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
const SET_JOB_APPLICATIONS = 'SET_JOB_APPLICATIONS';
const UNSET_JOB_APPLICATIONS = 'UNSET_JOB_APPLICATIONS';
const SET_CURRENT_APPLICATION = 'SET_CURRENT_APPLICATION';
const SET_SERVICE_HOURS_TIMESLOTS = 'SET_SERVICE_HOURS_TIMESLOTS';
const SET_CURRENT_TIMESLOT_INSTANCE = 'SET_CURRENT_TIMESLOT_INSTANCE';
const SET_OFFLINE_ATTENDANCE_FULL_LIST = 'SET_OFFLINE_ATTENDANCE_FULL_LIST'; // deprecated
const SET_OFFLINE_ATTENDANCE_CHANGES = 'SET_OFFLINE_ATTENDANCE_CHANGES'; // deprecated
const SET_ATTENDANCE_FULL_LIST = 'SET_ATTENDANCE_FULL_LIST';
const SET_EVENT_LISTENER_COUNT = 'SET_EVENT_LISTENER_COUNT';
const SET_EVENT_LISTENER = 'SET_EVENT_LISTENER';
const SET_DRAFT_APPLICATION = 'SET_DRAFT_APPLICATION';
const SET_ATTENDANCE_IMPORT_DATA = 'SET_ATTENDANCE_IMPORT_DATA';
const SET_ATTENDANCE_IMPORT_DATA_BY_INDEX =
	'SET_ATTENDANCE_IMPORT_DATA_BY_INDEX';
const ADD_AGE_TO_CURRENT_JOB_ADDITIONAL_QUESTIONS =
	'ADD_AGE_TO_CURRENT_JOB_ADDITIONAL_QUESTIONS';
const REMOVE_AGE_FROM_CURRENT_JOB_ADDITIONAL_QUESTIONS =
	'REMOVE_AGE_FROM_CURRENT_JOB_ADDITIONAL_QUESTIONS';
const UPDATE_UNIT_ADDITIONAL_QUESTIONS_TO_CURRENT_JOB =
	'UPDATE_UNIT_ADDITIONAL_QUESTIONS_TO_CURRENT_JOB';
const SET_APPLICATION_CACHE = 'SET_APPLICATION_CACHE';

export const JobActionKeys = {
	fetchByListType: 'fetchByListType',
	fetchTimeslotsBySessionId: 'fetchTimeslotsBySessionId',
	fetchTimeslotsById: 'fetchTimeslotsById',
	fetchEventTypes: 'fetchEventTypes',
	setLastJobList: 'setLastJobList',

	setCurrentJob: 'setCurrentJob',
	setCurrentCloneJob: 'setCurrentCloneJob',
	setCurrentJobValidations: 'setCurrentJobValidations',
	setCurrentSession: 'setCurrentSession',
	unsetCurrentSession: 'unsetCurrentSession',
	setCurrentJobSession: 'setCurrentJobSession',
	setCurrentJobSessions: 'setCurrentJobSessions',
	setJobSchedule: 'setJobSchedule',
	unsetCurrentJob: 'unsetCurrentJob',
	fetchJob: 'fetchJob',
	initializeJob: 'initializeJob',
	saveCurrentJob: 'saveCurrentJob',
	fetchVolunteerFunctions: 'fetchVolunteerFunctions',
	fetchSessionTypes: 'fetchSessionTypes',
	setCurrentStep: 'setCurrentStep',
	fetchApplications: 'fetchApplications',
	unsetApplications: 'unsetApplications',
	setCurrentApplication: 'setCurrentApplication',
	fetchApplication: 'fetchApplication',
	addSession: 'addSession',
	addDate: 'addDate',
	addTimeSlot: 'addTimeSlot',
	fetchTimeslotInstanceById: 'fetchTimeslotInstanceById',
	fetchAttendanceFullList: 'fetchAttendanceFullList',
	fetchAttendanceOfflineFullList: 'fetchAttendanceOfflineFullList', //deprecated
	setOfflineAttendanceChange: 'setOfflineAttendanceChange', //deprecated
	setOfflineAttendanceFullList: 'setOfflineAttendanceFullList', //deprecated
	updateFromLocalStorage: 'updateFromLocalStorage', // deprecated
	startLocalStorageListener: 'startLocalStorageListener', // deprecated
	stopLocalStorageListener: 'stopLocalStorageListener', // deprecated
	saveOfflineAttendanceChanges: 'saveOfflineAttendanceChanges', // deprecated

	//check in actions
	attendanceCheckIn: 'attendanceCheckIn',
	attendanceCheckOut: 'attendanceCheckOut',
	attendanceConfirmHours: 'attendanceConfirmHours',
	attendanceConfirm: 'attendanceConfirm',
	attendanceUnconfirm: 'attendanceUnconfirm',
	attendanceAbsent: 'attendanceAbsent',
	attendanceUndoCheckIn: 'attendanceUndoCheckIn',
	attendanceUndoCheckOut: 'attendanceUndoCheckOut',

	updateRemarks: 'updateRemarks',

	setDraftApplication: 'setDraftApplication',
	unsetDraftApplication: 'unsetDraftApplication',
	saveDraftApplication: 'saveDraftApplication',
	setAttendanceImportData: 'setAttendanceImportData',
	setAttendanceImportDataByIndex: 'setAttendanceImportDataByIndex',
	clearAttendanceImportData: 'clearAttendanceImportData',
	updateAgeQuestionForCurrentJobAgeRequirement:
		'updateAgeQuestionForCurrentJobAgeRequirement',
	updateUnitQuestionsForCurrentJob: 'updateUnitQuestionsForCurrentJob',
	fetchApplicationsByUserIds: 'fetchApplicationsByUserIds',
	updateApplicationCache: 'updateApplicationCache',
	setJobSubmitting: 'setJobSubmitting',
	unsetJobSubmitting: 'unsetJobSubmitting',
	unsetJobListPageData: 'unsetJobListPageData',
};

export const JobGetterKeys = {
	pageData: 'pageData',
	loading: 'loading',
	submitting: 'submitting',
	submitFrom: 'submitFrom',
	lastError: 'lastError',
	eventTypes: 'eventTypes',
	currentJob: 'currentJob',
	currentJobValidations: 'currentJobValidations',
	jobStatus: 'jobStatus',
	currentTimeslot: 'currentTimeslot',
	volunteerFunctions: 'volunteerFunctions',
	sessionTypes: 'sessionTypes',
	currentStep: 'currentStep',
	applicationsPageData: 'applicationsPageData',
	currentApplication: 'currentApplication',
	draftApplication: 'draftApplication',
	currentServiceHoursSession: 'currentServiceHoursSession',
	currentJobSessions: 'currentJobSessions',
	currentTimeslotInstance: 'currentTimeslotInstance',
	getSessionByPosition: 'getSessionByPosition',
	jobTimeslotPageData: 'jobTimeslotPageData',
	lastJobList: 'lastJobList',
	getAttendanceOfflineFullListByTimeslotInstance:
		'getAttendanceOfflineFullListByTimeslotInstance',
	getOfflineAttendanceChangesByTimeslotInstance:
		'getOfflineAttendanceChangesByTimeslotInstance', //deprecated
	attendanceFullList: 'attendanceFullList',
	attendanceImportData: 'attendanceImportData',
	currentJobHasAgeRequirement: 'currentJobHasAgeRequirement',
	applicationCache: 'applicationCache',
};

const fixTimeslotDateGroupIdAndPosition = (timeslots: JobTimeslot[]) => {
	timeslots = timeslots.sort((t1, t2) =>
		t1.dateGroupId === t2.dateGroupId
			? t1.position - t2.position
			: t1.dateGroupId - t2.dateGroupId,
	);

	// fix position
	let lastDateGroupId = -1,
		lastPosition = -1;
	timeslots = timeslots.map(timeslot => {
		if (lastDateGroupId !== timeslot.dateGroupId) {
			// first timeslot in dateGroup
			lastPosition = -1;
		}
		lastDateGroupId = timeslot.dateGroupId;
		return {
			...timeslot,
			position: ++lastPosition,
		};
	});

	// fix dateGroupId
	lastDateGroupId = -1;
	timeslots = timeslots.map(timeslot => {
		if (timeslot.position === 0) {
			// first timeslot in dateGroup
			lastDateGroupId++;
		}
		return {
			...timeslot,
			dateGroupId: lastDateGroupId,
		};
	});
	return timeslots;
};

const initialState: JobState = {
	submitting: false,
	submitFrom: null,
	loading: 0,
	lastError: '',
	eventTypes: [],
	sessionTypes: [],
	volunteerFunctions: [],
	currentJob: null,
	currentJobValidations: {},
	currentServiceHoursSession: undefined,
	currentStep: JobEditStep.basicInfo,
	applicationsPageData: undefined,
	currentApplication: null,
	currentDraftApplication: undefined,
	pageData: {},
	jobTimeslotPageData: {},
	currentTimeslot: undefined,
	currentTimeslotInstance: undefined,
	lastJobList: 'all',
	groupedOfflineAttendanceChanges: {},
	attendanceOfflineFullList: {},
	attendanceFullList: [],
	localStorageEventListenerCount: 0,
	attendanceImportData: [],
	applicationCache: {},
};

function updateAttendance(
	state: JobState,
	commit: Commit,
	attendance: JobAttendance,
) {
	const orgAttendances = state.attendanceFullList;
	const ind = orgAttendances.findIndex(att => att.id == attendance.id);
	if (ind >= 0) {
		const attendances = [...orgAttendances];
		attendances[ind] = {
			...orgAttendances[ind],
			...attendance,
		};

		commit(SET_ATTENDANCE_FULL_LIST, {
			attendances,
		});
	}
}

const store: Module<JobState, RootState> = {
	namespaced: true,

	state: { ...initialState },

	mutations: {
		[SHOW_SUBMITTING](state) {
			state.submitting = true;
		},

		[HIDE_SUBMITTING](state) {
			state.submitting = false;
		},

		[SET_SUBMIT_FROM](state, fromAction) {
			state.submitFrom = fromAction;
		},

		[UNSET_SUBMIT_FROM](state) {
			state.submitFrom = null;
		},

		[SHOW_LOADING](state) {
			state.loading += 1;
		},

		[HIDE_LOADING](state) {
			state.loading -= 1;
		},

		[SET_LAST_ERROR](state, error) {
			state.lastError = error;
		},

		[SET_LAST_JOB_LIST](state, lastJobList) {
			state.lastJobList = lastJobList;
		},

		[SET_JOBS](
			state,
			{ listType, pageData }: { listType: JobListType; pageData: JobPageData },
		) {
			state.pageData = { ...state.pageData, [listType]: pageData };
		},

		[SET_EVENT_TYPES](state, eventTypes) {
			state.eventTypes = eventTypes;
		},

		[SET_VOLUNTEER_FUNCTIONS](state, volunteerFunctions) {
			state.volunteerFunctions = volunteerFunctions;
		},

		[SET_SESSION_TYPES](state, sessionTypes) {
			state.sessionTypes = sessionTypes;
		},

		[SET_CURRENT_CLONE_JOB](
			state,
			{
				job,
				ownerCenterId,
				mainNotificationEmail,
			}: {
				job: JobDto | Job;
				ownerCenterId: number;
				mainNotificationEmail: string;
			},
		) {
			const clonedJob = cloneDeep(job);
			clonedJob.id = undefined;
			clonedJob.status = JobStatusCode.draft;
			clonedJob.createdAt = undefined;
			clonedJob.updatedAt = undefined;
			clonedJob.jobLink = undefined;
			clonedJob.cancelReason = undefined;

			//patch for "incomplete" 1.0 migrated jobs
			if (!clonedJob.volunteerInfo) {
				clonedJob.volunteerInfo = {
					volunteerFunctions: [],
					skills: [],
					languages: [],
				};
			}

			// schedule fields
			clonedJob.sessions?.forEach(session => {
				session.id = undefined;
				session.job = undefined;
				session.jobId = undefined;
				session.createdAt = undefined;
				session.updatedAt = undefined;
				session.timeslots?.forEach(timeslot => {
					timeslot.id = undefined;
					timeslot.session = undefined;
					timeslot.sessionId = undefined;
					timeslot.volunteerCount = 0;
					timeslot.usedQuota = 0;
					timeslot.acceptedQuota = 0;
					timeslot.pendingQuota = 0;
					timeslot.createdAt = undefined;
					timeslot.updatedAt = undefined;
				});
			});

			// other settings fields
			clonedJob.collaboratorAllCenters = false;
			clonedJob.collaboratorCenterIds = [];
			clonedJob.ownerCenterId = ownerCenterId;
			clonedJob.mainNotificationEmail = mainNotificationEmail;
			clonedJob.extraNotificationEmails = [];
			clonedJob.addedToReports = undefined;

			// technically these value should be zero on new create
			// unless the clone job logic fully revamped
			// And this clone logic is further safeguard on BE when update on first create job
			clonedJob.acceptedQuota = 0;
			clonedJob.pendingApplications = 0;

			// remove timeslot created from import for internal job
			// assume internal job will only has 1 session
			if (clonedJob.isInternal && clonedJob.sessions) {
				const defaultSession = clonedJob.sessions[0];
				const defaultTimeslot = defaultSession.timeslots!.find(ts => ts.isMain);
				clonedJob.sessions[0].timeslots = defaultTimeslot
					? [defaultTimeslot]
					: [];
			}
			state.currentJob = clonedJob;
		},

		[SET_CURRENT_JOB](state, job: JobDto | null) {
			state.currentJob = job;
		},

		[SET_CURRENT_JOB_VALIDATIONS](state, validations) {
			state.currentJobValidations = validations;
		},

		[SET_CURRENT_SESSION](state, session: JobSession) {
			state.currentServiceHoursSession = session;
		},

		[SET_CURRENT_TIMESLOT](state, timeslot: JobTimeslot) {
			state.currentTimeslot = timeslot;
		},

		[SET_CURRENT_JOB_SESSION_BY_POSITION](
			state,
			{ position, session }: { position: number; session: JobSession },
		) {
			const sessionIndex =
				state.currentJob?.sessions?.findIndex(
					session => session.position === position,
				) ?? -1;
			if (!state.currentJob) throw new Error('Missing currentJob');
			if (!state.currentJob.sessions) {
				Vue.set(state.currentJob, 'sessions', []);
			}
			if (sessionIndex < 0) {
				throw new Error(`Job session at position ${position} not found`);
			}
			// sort timeslots and correct dateGroupId & position
			if (session.timeslots) {
				session.timeslots = fixTimeslotDateGroupIdAndPosition(
					session.timeslots || [],
				);
			}

			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			Vue.set(state.currentJob.sessions!, sessionIndex, session);
		},

		[SET_CURRENT_JOB_SESSION_SCHEDULE_BY_POSITION](
			state,
			{
				sessionPosition,
				schedulePosition,
				scheduleDateGroupId,
				schedule,
			}: {
				sessionPosition: number;
				schedulePosition: number;
				scheduleDateGroupId: number;
				schedule: JobTimeslot;
			},
		) {
			const sessionIndex =
				state.currentJob?.sessions?.findIndex(
					session => session.position === sessionPosition,
				) ?? -1;
			if (!state.currentJob) throw new Error('Missing currentJob');
			if (!state.currentJob.sessions) {
				Vue.set(state.currentJob, 'sessions', []);
			}
			if (sessionIndex < 0) {
				throw new Error(`Job session at position ${sessionPosition} not found`);
			}

			if (!state.currentJob.sessions) throw new Error('Missing currentJob');
			const session = state.currentJob.sessions[sessionIndex];
			const scheduleIndex =
				session.timeslots?.findIndex(
					timeslot =>
						timeslot.position === schedulePosition &&
						timeslot.dateGroupId === scheduleDateGroupId,
				) ?? -1;
			if (scheduleIndex < 0) {
				throw new Error(
					`Job schedule at position ${schedulePosition} ${scheduleDateGroupId} not found`,
				);
			}

			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			Vue.set(session.timeslots!, scheduleIndex, schedule);
		},

		[SET_CURRENT_STEP](state, step: JobEditStep) {
			state.currentStep = step;
		},

		[ADD_AGE_TO_CURRENT_JOB_ADDITIONAL_QUESTIONS](state) {
			if (!state.currentJob) {
				return;
			}
			const additionalQuestions = state.currentJob.additionalQuestions ?? [];
			if (!additionalQuestions.find(question => question.key === 'age'))
				additionalQuestions.unshift({
					key: 'age',
					desc: { en: 'Age', zhHant: '年齡', zhHans: '年龄' },
					type: BasicFieldType.INTEGER,
					mandatory: true,
					protected: true,
				});
			Vue.set(state.currentJob, 'additionalQuestions', additionalQuestions);
		},

		[REMOVE_AGE_FROM_CURRENT_JOB_ADDITIONAL_QUESTIONS](state) {
			if (!state.currentJob?.additionalQuestions) {
				return;
			}
			Vue.set(
				state.currentJob,
				'additionalQuestions',
				state.currentJob.additionalQuestions.filter(question => {
					return question.key !== 'age';
				}),
			);
		},

		[UPDATE_UNIT_ADDITIONAL_QUESTIONS_TO_CURRENT_JOB](state, { questions }) {
			if (!state.currentJob) {
				return;
			}
			const additionalQuestions =
				state.currentJob.additionalQuestions?.filter(
					question => !question.key?.startsWith('unit_'),
				) ?? [];
			questions.forEach((question: any) => {
				additionalQuestions.push({
					...question,
					protected: true,
				});
			});
			Vue.set(state.currentJob, 'additionalQuestions', additionalQuestions);
		},

		[SET_JOB_APPLICATIONS](
			state,
			{ pageData }: { pageData: JobApplicationPageData },
		) {
			state.applicationsPageData = pageData;
		},

		[UNSET_JOB_APPLICATIONS](state) {
			state.applicationsPageData = undefined;
		},

		[SET_CURRENT_APPLICATION](state, application: JobApplication | null) {
			state.currentApplication = application;
		},

		[SET_SERVICE_HOURS_TIMESLOTS](
			state,
			{
				sessionId,
				jobTimeslotPageData,
			}: { sessionId: string; jobTimeslotPageData: JobTimeslotPageData },
		) {
			state.jobTimeslotPageData = {
				...state.jobTimeslotPageData,
				[sessionId]: jobTimeslotPageData,
			};
		},

		[SET_CURRENT_TIMESLOT_INSTANCE](
			state,
			timeslotInstance: JobTimeslotInstance,
		) {
			state.currentTimeslotInstance = timeslotInstance;
		},

		[SET_OFFLINE_ATTENDANCE_FULL_LIST](
			state,
			{
				timeslotInstanceId,
				attendances,
				userId,
				skipLocalStorageUpdate,
			}: {
				timeslotInstanceId: string;
				attendances: JobAttendance[];
				userId?: string;
				skipLocalStorageUpdate?: boolean;
			},
		) {
			Vue.set(state.attendanceOfflineFullList, timeslotInstanceId, attendances);

			if (!skipLocalStorageUpdate) {
				// save to localStorage
				const key = `${JOB_ATTENDANCE_FULL_LIST}_${userId}`;
				const localData = JSON.parse(localStorage.getItem(key) || '{}');
				localData[timeslotInstanceId] = attendances;
				localStorage.setItem(key, JSON.stringify(localData));
			}
		},

		[SET_OFFLINE_ATTENDANCE_CHANGES](
			state,
			{
				timeslotInstanceId,
				offlineAttendanceChanges,
				userId,
				skipLocalStorageUpdate,
			}: {
				timeslotInstanceId: string;
				offlineAttendanceChanges: JobOfflineAttendanceChange[];
				userId?: string;
				skipLocalStorageUpdate?: boolean;
			},
		) {
			Vue.set(
				state.groupedOfflineAttendanceChanges,
				timeslotInstanceId,
				offlineAttendanceChanges,
			);
			if (!skipLocalStorageUpdate) {
				// update storage, too
				const key = `${JOB_GROUPED_OFFLINE_ATTENDANCE_CHANGES}_${userId}`;
				localStorage.setItem(
					key,
					JSON.stringify(state.groupedOfflineAttendanceChanges),
				);
			}
		},

		[SET_ATTENDANCE_FULL_LIST](
			state,
			{
				attendances,
			}: {
				attendances: JobAttendance[];
			},
		) {
			state.attendanceFullList = attendances;
		},

		[SET_EVENT_LISTENER](state, { listener }) {
			if (!state.localStorageEventListenerFunction) {
				state.localStorageEventListenerFunction = listener;
				//note: this event will only be triggered with update in other windows
				window.addEventListener('storage', listener);
			}
		},

		[SET_EVENT_LISTENER_COUNT](state, { count }) {
			state.localStorageEventListenerCount = count;
		},

		[SET_DRAFT_APPLICATION](state, draftApplication: JobApplicationDto) {
			state.currentDraftApplication = draftApplication;
		},

		[SET_ATTENDANCE_IMPORT_DATA](state, data: JobAttendanceImportTableItem[]) {
			state.attendanceImportData = data;
		},

		[SET_ATTENDANCE_IMPORT_DATA_BY_INDEX](
			state,
			{ item, index }: { item: JobAttendanceImportTableItem; index: number },
		) {
			Vue.set(state.attendanceImportData, index, item);
		},

		[SET_APPLICATION_CACHE](state, applicationCache: JobApplicationCache) {
			state.applicationCache = applicationCache;
		},
	},

	actions: {
		async [JobActionKeys.fetchByListType](
			{ commit },
			{
				options,
				listType,
				progress,
				reportId,
				periodConstraints,
				centerIds,
			}: {
				options: TableItemsOptions;
				listType: JobListType;
				progress?: string | string[];
				reportId?: string;
				periodConstraints?: PeriodConstraints;
				centerIds?: number[];
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.job.fetchJobTableItems(
					options,
					listType,
					progress,
					reportId,
					periodConstraints,
					centerIds,
				);
				commit(SET_JOBS, {
					listType,
					pageData: { items: data?.result, total: data?.total },
				});
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.unsetJobListPageData]({ commit }, listType: JobListType) {
			commit(SET_JOBS, { listType, pageData: { items: [], total: 0 } });
		},

		async [JobActionKeys.fetchTimeslotsBySessionId](
			{ commit },
			{
				options,
				jobId,
				sessionId,
			}: {
				options: TableItemsOptions;
				jobId: string;
				sessionId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.job.fetchJobTimeslots(options, jobId, sessionId);
				commit(SET_SERVICE_HOURS_TIMESLOTS, {
					sessionId,
					jobTimeslotPageData: { items: data?.result, total: data?.total },
				});
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			} finally {
				commit(HIDE_LOADING);
			}
		},
		async [JobActionKeys.fetchTimeslotsById](
			{ commit },
			{
				id,
			}: {
				id: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.job.fetchJobTimeslotById(id);
				commit(SET_CURRENT_TIMESLOT, data);
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [JobActionKeys.fetchEventTypes]({ state, commit }) {
			if (!state.eventTypes?.length) {
				try {
					commit(SHOW_LOADING);
					commit(SET_EVENT_TYPES, await api.fetchJobEventTypes());
				} catch (error) {
					commit(SET_LAST_ERROR, error);
				} finally {
					commit(HIDE_LOADING);
				}
			}
		},
		async [JobActionKeys.fetchVolunteerFunctions]({ state, commit }) {
			if (!state.volunteerFunctions?.length) {
				try {
					commit(SHOW_LOADING);
					commit(SET_VOLUNTEER_FUNCTIONS, await api.fetchVolunteerFunctions());
				} catch (error) {
					commit(SET_LAST_ERROR, error);
				} finally {
					commit(HIDE_LOADING);
				}
			}
		},

		/**
		 * Session
		 */

		async [JobActionKeys.fetchSessionTypes]({ commit }) {
			try {
				commit(SHOW_LOADING);
				const sessionTypes = await api.job.fetchJobSessionTypes();
				commit(SET_SESSION_TYPES, sessionTypes);
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.setLastJobList](
			{ commit },
			{ jobList }: { jobList: string },
		) {
			commit(SET_LAST_JOB_LIST, jobList);
		},

		[JobActionKeys.setCurrentCloneJob](
			{ commit },
			{
				job,
				ownerCenterId,
				mainNotificationEmail,
			}: {
				job: JobDto | Job;
				ownerCenterId: number;
				mainNotificationEmail: string;
			},
		) {
			commit(SET_CURRENT_JOB_VALIDATIONS, {});
			commit(SET_CURRENT_CLONE_JOB, {
				job,
				ownerCenterId,
				mainNotificationEmail,
			});
		},

		[JobActionKeys.setCurrentJob]({ commit }, { job }: { job: JobDto }) {
			commit(SET_CURRENT_JOB, job);
		},

		[JobActionKeys.setCurrentJobValidations]({ commit }, { validations }) {
			commit(SET_CURRENT_JOB_VALIDATIONS, validations);
		},

		[JobActionKeys.setCurrentSession](
			{ commit },
			{ session }: { session: JobSession },
		) {
			commit(SET_CURRENT_SESSION, session);
		},

		[JobActionKeys.setCurrentJobSession](
			{ commit },
			{ position, session }: { position: number; session: JobSession },
		) {
			commit(SET_CURRENT_JOB_SESSION_BY_POSITION, { position, session });
		},

		[JobActionKeys.unsetCurrentSession]({ commit }) {
			commit(SET_CURRENT_SESSION, null);
		},

		[JobActionKeys.setCurrentJobSession](
			{ commit },
			{ position, session }: { position: number; session: JobSession },
		) {
			commit(SET_CURRENT_JOB_SESSION_BY_POSITION, { position, session });
		},

		[JobActionKeys.setCurrentJobSessions](
			{ getters, commit },
			{ sessions }: { sessions: JobSession[] },
		) {
			const currentJob: Job | JobDto = getters[JobGetterKeys.currentJob];
			commit(SET_CURRENT_JOB, {
				...currentJob,
				sessions: sessions.map((session, index) => ({
					...session,
					position: index, // re-assign position index
				})),
			});
		},

		[JobActionKeys.addSession](
			{ getters, commit },
			{ sessionType }: { sessionType: JobSessionType },
		) {
			const currentJob: Job | JobDto = getters[JobGetterKeys.currentJob];
			const currentJobSessions: JobSession[] =
				getters[JobGetterKeys.currentJobSessions];
			const sessions: JobSession[] = [
				...currentJobSessions,
				{
					type: sessionType.code,
					title: cloneDeep(sessionType.name),
					position: currentJobSessions.length,
					timeslots: [
						defaultTimeSlotFactory({
							dateGroupId: 0,
							position: 0,
							isAllDay: false,
							isDateTBC: false,
							isSingleDay: true,
							endDate: null,
							isTimeTBC: false,
							quota: null,
						}),
					],
					frequency: ScheduleFrequency.oneOff,
				},
			];
			commit(SET_CURRENT_JOB, {
				...currentJob,
				sessions,
			});
		},

		/**
		 * Schedule
		 */

		[JobActionKeys.setJobSchedule](
			{ commit },
			{
				sessionPosition,
				schedulePosition,
				scheduleDateGroupId,
				schedule,
			}: {
				sessionPosition: number;
				schedulePosition: number;
				scheduleDateGroupId: number;
				schedule: JobTimeslot;
			},
		) {
			commit(SET_CURRENT_JOB_SESSION_SCHEDULE_BY_POSITION, {
				sessionPosition,
				schedulePosition,
				scheduleDateGroupId,
				schedule,
			});
		},

		[JobActionKeys.addDate](
			{ getters, commit },
			{
				sessionPosition,
				initData,
			}: { sessionPosition: number; initData?: Partial<JobTimeslot> },
		) {
			const session: JobSession | undefined = getters[
				JobGetterKeys.getSessionByPosition
			](sessionPosition);
			if (!session) throw new Error('No session');
			const oldTimeSlots = session?.timeslots || [];
			const maxDateGroupId = oldTimeSlots.reduce(
				(max, timeslot) => Math.max(timeslot.dateGroupId, max),
				-1,
			);
			const newTimeslot = defaultTimeSlotFactory({
				position: 0,
				dateGroupId: maxDateGroupId + 1,

				isSingleDay: session.frequency === ScheduleFrequency.oneOff,
				isDateTBC: false,

				// Time Slot
				isAllDay: false,
				isTimeTBC: false,

				// quota
				quota: null,

				// overwrite with initData
				...initData,
			});

			commit(SET_CURRENT_JOB_SESSION_BY_POSITION, {
				position: sessionPosition,
				session: {
					...session,
					timeslots: [...oldTimeSlots, newTimeslot],
				},
			});
		},

		[JobActionKeys.addTimeSlot](
			{ getters, commit },
			{
				sessionPosition,
				dateGroupId,
				position,
				initData,
			}: {
				sessionPosition: number;
				dateGroupId: number;
				position: number;
				initData?: Partial<JobTimeslot>;
			},
		) {
			const session: JobSession | undefined = getters[
				JobGetterKeys.getSessionByPosition
			](sessionPosition);
			if (!session?.timeslots?.length)
				throw new Error('No session or session missing timeslots');
			const oldTimeSlots = session.timeslots;
			const oldTimeSlotsOnSameDate = oldTimeSlots.find(
				timeslot => timeslot.dateGroupId === dateGroupId,
			);
			if (!oldTimeSlotsOnSameDate) {
				throw new Error('Missing timeslot with same date');
			}

			// Create Default schedule
			const newTimeSlot = defaultTimeSlotFactory({
				dateGroupId,
				position,
				// only inherit certain values from oldTimeSlotsOnSameDate
				isSingleDay: oldTimeSlotsOnSameDate.isSingleDay,
				isDateTBC: oldTimeSlotsOnSameDate.isDateTBC,

				// override startDate & endDate
				startDate: oldTimeSlotsOnSameDate.startDate,
				endDate: oldTimeSlotsOnSameDate.endDate,
				// Time Slot
				isAllDay: false,
				isTimeTBC: false,

				// quota
				quota: null,

				// overwrite with initData
				...initData,
			});

			// update State
			commit(SET_CURRENT_JOB_SESSION_BY_POSITION, {
				position: sessionPosition,
				session: {
					...session,
					timeslots: [...oldTimeSlots, newTimeSlot],
				},
			});
		},

		/**
		 * Basic
		 */
		[JobActionKeys.unsetCurrentJob]({ commit }) {
			commit(SET_CURRENT_JOB_VALIDATIONS, {});
			commit(SET_CURRENT_JOB, null);
		},
		async [JobActionKeys.fetchJob]({ commit }, { id }: { id: string }) {
			const job = await api.job.fetchJob(id);
			commit(SET_CURRENT_JOB_VALIDATIONS, job.validations);
			delete job.validations;
			commit(SET_CURRENT_JOB, job);
		},
		/**
		 * Initialize job with partialJob as the base
		 */
		[JobActionKeys.initializeJob](
			{ commit },
			{ partialJob }: { partialJob: Partial<Job> },
		) {
			if (!partialJob.mainNotificationEmail) {
				throw 'Missing mainNotificationEmail';
			}
			commit(SET_CURRENT_JOB_VALIDATIONS, {});
			commit(SET_CURRENT_JOB, {
				collaboratorAllCenters: false,
				collaboratorCenterIds: [],
				status: JobStatusCode.draft,
				title: EmptyMultiLangText,
				basicInfo: {
					causes: [],
					recipients: [],
					sdgs: [],
				},
				isInternal: false,
				description: EmptyMultiLangText,
				remarks: EmptyMultiLangText,
				keywords: [],
				imageUrls: [],
				sessions: [],
				volunteerInfo: {
					volunteerFunctions: [],
					skills: [],
					languages: [],
				},
				parentalConsent: false,
				pcAge: null,
				quota: 0,
				groupApply: null,
				applicationStart: null,
				applicationEnd: null,
				visibility: null,
				applicationRestrictions: null,
				inviteMembers: null,
				feeDetail: null,
				contact: null,
				contactEmail: null,
				contactPhone: null,
				autoApprove: false,
				overallStart: null,
				overallEnd: null,
				serviceStart: null,
				serviceEnd: null,
				jobLink: null,
				extraNotificationEmails: [],
				...partialJob,
			} as JobDto);
		},

		async [JobActionKeys.saveCurrentJob]({ state, commit }) {
			if (!state.currentJob) throw new Error('Empty currentJob');
			let job: Job;
			// isNew field only used in frontend to track if the question is new
			state.currentJob.additionalQuestions = state.currentJob.additionalQuestions?.map(
				question => {
					delete question.isNew;
					return question;
				},
			);
			if (state.currentJob.id) {
				job = await api.job.updateJob(
					state.currentJob.id,
					state.currentJob,
					state.currentJobValidations,
				);
			} else {
				job = await api.job.createJob(
					state.currentJob,
					state.currentJobValidations,
				);
			}
			if (!job) throw new Error('Empty job creation result');
			commit(SET_CURRENT_JOB, job);
			return job;
		},

		[JobActionKeys.setCurrentStep]({ commit }, { step }) {
			commit(SET_CURRENT_STEP, step);
		},

		[JobActionKeys.updateAgeQuestionForCurrentJobAgeRequirement]({
			commit,
			getters,
		}) {
			if (getters[JobGetterKeys.currentJobHasAgeRequirement]) {
				commit(ADD_AGE_TO_CURRENT_JOB_ADDITIONAL_QUESTIONS);
			} else {
				commit(REMOVE_AGE_FROM_CURRENT_JOB_ADDITIONAL_QUESTIONS);
			}
		},

		async [JobActionKeys.updateUnitQuestionsForCurrentJob]({ state, commit }) {
			if (state.currentJob) {
				const unitQuestions = await api.job.fetchPresetQuestions({
					centerId: state.currentJob.ownerCenterId,
					type: 'job',
				});
				commit(UPDATE_UNIT_ADDITIONAL_QUESTIONS_TO_CURRENT_JOB, {
					questions: unitQuestions.flatMap(uq => uq.additionalQuestions),
				});
			}
		},

		async [JobActionKeys.fetchTimeslotInstanceById](
			{ commit, state },
			{ id }: { id: string },
		) {
			const timeslotInstance = await api.job.fetchJobTimeslotInstance(id);
			const session = timeslotInstance.timeslot?.session;
			commit(SET_CURRENT_TIMESLOT_INSTANCE, timeslotInstance);
			if (session && !state.currentServiceHoursSession) {
				// set session, too
				commit(SET_CURRENT_SESSION, session);
			}
		},

		/**
		 * attendance
		 */
		async [JobActionKeys.fetchAttendanceFullList](
			{ commit, rootGetters, dispatch },
			{
				timeslotInstanceId,
			}: {
				timeslotInstanceId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const options = {
					page: 1,
					itemsPerPage: 5000,
					sortBy: [],
					sortDesc: [],
					groupBy: [],
					groupDesc: [],
					multiSort: false,
					mustSort: false,
					search: { headers: [], text: '' },
					filter: [],
					filterParams: {},
				};

				const { result: attendances } = await api.job.fetchJobAttendanceList(
					options,
					timeslotInstanceId,
				);

				commit(SET_ATTENDANCE_FULL_LIST, { attendances });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [JobActionKeys.fetchAttendanceOfflineFullList](
			{ commit, rootGetters, dispatch },
			{
				timeslotInstanceId,
			}: {
				timeslotInstanceId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const options = {
					page: 1,
					itemsPerPage: 5000,
					sortBy: [],
					sortDesc: [],
					groupBy: [],
					groupDesc: [],
					multiSort: false,
					mustSort: false,
					search: { headers: [], text: '' },
					filter: [],
					filterParams: {},
				};

				const { result: attendances } = await api.job.fetchJobAttendanceList(
					options,
					timeslotInstanceId,
				);

				const userId = rootGetters[`auth/${AuthGetterKeys.userId}`];
				dispatch(JobActionKeys.setOfflineAttendanceFullList, {
					userId,
					timeslotInstanceId,
					attendances,
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [JobActionKeys.fetchApplications](
			{ commit },
			{
				options,
				jobId,
			}: {
				options: TableItemsOptions;
				jobId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.job.fetchJobApplicationTableItems(
					options,
					jobId,
				);
				commit(SET_JOB_APPLICATIONS, {
					jobId,
					pageData: { items: data?.result, total: data?.total },
				});
			} catch (error) {
				commit(SET_LAST_ERROR, error);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [JobActionKeys.unsetApplications]({ commit }) {
			commit(UNSET_JOB_APPLICATIONS);
		},

		[JobActionKeys.setCurrentApplication](
			{ commit },
			{ application }: { application: JobApplication },
		) {
			commit(SET_CURRENT_APPLICATION, application);
		},

		async [JobActionKeys.fetchApplication]({ commit }, { id }) {
			const application = await api.job.fetchJobApplicationById(id);
			commit(SET_CURRENT_APPLICATION, application);
		},

		// async [JobActionKeys.bulkCheckIn](
		// 	{ getters, rootGetters, dispatch },
		// 	{ timeslotInstanceId },
		// ) {
		// 	const userId = rootGetters[`auth/${AuthGetterKeys.userId}`];
		// 	const draftAttendances =
		// 		getters[JobGetterKeys.offlineAttendanceChanges][timeslotInstanceId];

		// 	if (draftAttendances?.length) {
		// 		await api.job.saveRecordedCheckin(checkIns);
		// 	}
		// 	await dispatch(JobActionKeys.fetchAttendanceOfflineFullList, {
		// 		timeslotInstanceId,
		// 	});

		// 	// delete offline records for this timeslot instance
		// 	delete offlineCheckins[timeslotInstanceId];
		// 	dispatch(JobActionKeys.setOfflineCheckins, { userId, offlineCheckins });
		// },

		[JobActionKeys.setOfflineAttendanceChange](
			{ getters, commit, rootGetters },
			{
				timeslotInstanceId,
				attendanceChange,
			}: {
				timeslotInstanceId: string;
				attendanceChange: JobOfflineAttendanceChange;
			},
		) {
			const {
				id: attendanceId,
				checkInAt: rawCheckInAt,
				checkOutAt: rawCheckOutAt,
				...otherChange
			} = attendanceChange;
			const oldChanges: JobOfflineAttendanceChange[] = getters[
				JobGetterKeys.getOfflineAttendanceChangesByTimeslotInstance
			](timeslotInstanceId);

			const attendances: JobAttendance[] = getters[
				JobGetterKeys.getAttendanceOfflineFullListByTimeslotInstance
			](timeslotInstanceId);

			const attendance = attendances.find(a => a.id === attendanceId);

			if (!attendance) {
				throw `Cannot find attendance with ID "${attendanceId}"`;
			}

			let change: JobOfflineAttendanceChange = oldChanges.find(
				a => a.id === attendanceId,
			) || { id: attendanceId };
			change = Object.assign(change, otherChange);
			if (rawCheckInAt) {
				change.checkInAt = roundToNearestMinutes(new Date(rawCheckInAt));
			}
			if (rawCheckOutAt) {
				change.checkOutAt = roundToNearestMinutes(new Date(rawCheckOutAt));
			}

			// calculate calculatedHours
			const checkInAt = change.checkInAt || attendance?.checkInAt;
			const checkOutAt = change.checkOutAt || attendance?.checkOutAt;
			change.confirmedHours =
				change.confirmedHours ?? attendance.confirmedHours;
			if (checkInAt && checkOutAt) {
				change.calculatedHours =
					(new Date(checkOutAt).getTime() - new Date(checkInAt).getTime()) /
					(60 * 60 * 1000); // milliseconds to hours

				if (change.confirmedHours == null) {
					change.confirmedHours = change.calculatedHours;
				}
			}

			const otherDraftAttendances = oldChanges.filter(
				a => a.id !== attendanceId,
			);
			const offlineAttendanceChanges: JobOfflineAttendanceChange[] = [
				...otherDraftAttendances,
				change,
			];

			const userId = rootGetters[`auth/${AuthGetterKeys.userId}`];
			commit(SET_OFFLINE_ATTENDANCE_CHANGES, {
				userId,
				timeslotInstanceId,
				offlineAttendanceChanges,
			});
		},

		[JobActionKeys.setOfflineAttendanceFullList](
			{ commit },
			{
				userId,
				timeslotInstanceId,
				attendances,
			}: {
				userId: string;
				timeslotInstanceId: string;
				attendances: JobAttendance[];
			},
		) {
			try {
				commit(SHOW_LOADING);
				commit(SET_OFFLINE_ATTENDANCE_FULL_LIST, {
					userId,
					timeslotInstanceId,
					attendances,
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.updateFromLocalStorage]({ commit, state, rootGetters }) {
			try {
				commit(SHOW_LOADING);
				const userId = rootGetters[`auth/${AuthGetterKeys.userId}`];
				const key1 = `${JOB_GROUPED_OFFLINE_ATTENDANCE_CHANGES}_${userId}`;
				const groupedOfflineAttendanceChanges = JSON.parse(
					localStorage.getItem(key1) || '{}',
				);

				for (const timeslotInstanceId in groupedOfflineAttendanceChanges) {
					commit(SET_OFFLINE_ATTENDANCE_CHANGES, {
						timeslotInstanceId,
						offlineAttendanceChanges:
							groupedOfflineAttendanceChanges[timeslotInstanceId],
						skipLocalStorageUpdate: true,
					});
				}

				const key2 = `${JOB_ATTENDANCE_FULL_LIST}_${userId}`;
				const localData = JSON.parse(localStorage.getItem(key2) || '{}');

				for (const timeslotInstanceId in state.attendanceOfflineFullList) {
					commit(SET_OFFLINE_ATTENDANCE_FULL_LIST, {
						timeslotInstanceId,
						attendances: localData[timeslotInstanceId],
						skipLocalStorageUpdate: true,
					});
				}
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.startLocalStorageListener]({ commit, dispatch, state }) {
			let count = state.localStorageEventListenerCount;
			if (count < 0) {
				count = 0;
			}

			if (count === 0) {
				commit(SET_EVENT_LISTENER, {
					listener: () => {
						dispatch(JobActionKeys.updateFromLocalStorage);
					},
				});
			}

			count = count + 1; //don't use ++, count is reference to state field
			commit(SET_EVENT_LISTENER_COUNT, {
				count,
			});
		},

		[JobActionKeys.stopLocalStorageListener]({ commit, state }) {
			let count = state.localStorageEventListenerCount;
			count = count - 1; //don't use --, count is reference to state field
			if (count < 0) {
				count = 0;
			}

			if (count === 0 && state.localStorageEventListenerFunction) {
				window.removeEventListener(
					'storage',
					state.localStorageEventListenerFunction,
				);
			}

			commit(SET_EVENT_LISTENER_COUNT, {
				count,
			});
		},

		async [JobActionKeys.saveOfflineAttendanceChanges](
			{ getters, rootGetters, commit, dispatch },
			{ timeslotInstanceId }: { timeslotInstanceId: string },
		) {
			const changes: JobOfflineAttendanceChange[] = getters[
				JobGetterKeys.getOfflineAttendanceChangesByTimeslotInstance
			](timeslotInstanceId);
			const { succeeded, failed } = await api.job.saveJobAttendance(
				// do the map change only to data sent to API. Still keep original data if save fails
				changes.map((change: JobOfflineAttendanceChange) => ({
					...change,
					// exclude calculatedHours
					calculatedHours: undefined,
				})),
			);

			if (failed?.length) {
				dispatch(
					`alert/${AlertActionKeys.error}`,
					i18n.t('errors.unknownError'),
					{
						root: true,
					},
				);
			}

			// remove succeeded and keep failed ones
			const userId = rootGetters[`auth/${AuthGetterKeys.userId}`];
			commit(SET_OFFLINE_ATTENDANCE_CHANGES, {
				userId,
				timeslotInstanceId,
				offlineAttendanceChanges: changes.filter(
					c => !succeeded.includes(c.id),
				),
			});
		},

		async [JobActionKeys.attendanceCheckIn](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.checkin(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceCheckOut](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.checkout(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceUndoCheckIn](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.undoCheckIn(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceUndoCheckOut](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.undoCheckOut(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceConfirmHours](
			{ commit, state },
			{
				attendanceId,
				hours,
			}: {
				attendanceId: string;
				hours: number;
			},
		) {
			const attendance = await api.job.confirmHours(attendanceId, hours);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceConfirm](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.confirm(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceUnconfirm](
			{ commit, state },
			{ attendanceId }: { attendanceId: string },
		) {
			const attendance = await api.job.unconfirm(attendanceId);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.attendanceAbsent](
			{ commit, state },
			{
				attendanceId,
				absentReason,
			}: {
				attendanceId: string;
				absentReason: string;
			},
		) {
			const attendance = await api.job.absent(attendanceId, absentReason);
			updateAttendance(state, commit, attendance);
		},

		async [JobActionKeys.updateRemarks](
			{ commit, state },
			{
				attendanceId,
				remarks,
			}: {
				attendanceId: string;
				remarks: string;
			},
		) {
			const attendance = await api.job.updateJobAttendanceRemarks(
				attendanceId,
				remarks,
			);
			updateAttendance(state, commit, attendance);
		},

		// application
		[JobActionKeys.setDraftApplication](
			{ commit },
			{ application }: { application: JobApplicationDto },
		) {
			commit(SET_DRAFT_APPLICATION, application);
		},

		[JobActionKeys.unsetDraftApplication]({ commit }) {
			commit(SET_DRAFT_APPLICATION, undefined);
		},

		[JobActionKeys.saveDraftApplication]({ state }) {
			if (!state.currentDraftApplication) {
				throw ' Missing draftApplication';
			}
			if (state.currentDraftApplication.id) {
				return api.job.updateJobApplication(state.currentDraftApplication.id, {
					firstName: state.currentDraftApplication.firstName,
					lastName: state.currentDraftApplication.lastName,
					chineseName: state.currentDraftApplication.chineseName,
					email: state.currentDraftApplication?.email,
					mobileNumber: state.currentDraftApplication.mobileNumber,
					timeslots: state.currentDraftApplication.timeslots,
				});
			} else {
				return api.job.createJobApplication(state.currentDraftApplication);
			}
		},

		[JobActionKeys.setAttendanceImportData](
			{ commit },
			{ data }: { data: JobAttendanceImportTableItem[] },
		) {
			try {
				commit(SHOW_LOADING);
				commit(SET_ATTENDANCE_IMPORT_DATA, data);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.setAttendanceImportDataByIndex](
			{ commit },
			{ item, index }: { item: JobAttendanceImportTableItem; index: number },
		) {
			try {
				commit(SHOW_LOADING);
				commit(SET_ATTENDANCE_IMPORT_DATA_BY_INDEX, { item, index });
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[JobActionKeys.clearAttendanceImportData]({ commit }) {
			try {
				commit(SHOW_LOADING);
				commit(SET_ATTENDANCE_IMPORT_DATA, []);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [JobActionKeys.fetchApplicationsByUserIds](
			{ commit, state },
			{ jobId, userIds }: { jobId: string; userIds: string[] },
		) {
			const applications = await api.job.fetchJobApplications({
				jobId,
				userIds,
			});
			const applicationCache = state.applicationCache;
			for (const application of applications) {
				const userId = application.userId;
				if (!applicationCache[userId]) {
					applicationCache[userId] = {};
				}
				applicationCache[userId][application.jobId] = application;
			}
			commit(SET_APPLICATION_CACHE, applicationCache);
		},

		[JobActionKeys.updateApplicationCache](
			{ commit, state },
			{ userId, application }: { userId: string; application: JobApplication },
		) {
			const applicationCache = state.applicationCache;
			if (!applicationCache[userId]) {
				applicationCache[userId] = {};
			}
			applicationCache[userId][application.jobId] = application;
			commit(SET_APPLICATION_CACHE, applicationCache);
		},

		[JobActionKeys.setJobSubmitting]({ commit }, fromAction) {
			commit(SHOW_SUBMITTING);
			commit(SET_SUBMIT_FROM, fromAction);
		},

		[JobActionKeys.unsetJobSubmitting]({ commit }) {
			commit(HIDE_SUBMITTING);
			commit(UNSET_SUBMIT_FROM);
		},
	},

	getters: {
		[JobGetterKeys.pageData]: state => (jobListType: JobListType) => {
			return state.pageData[jobListType];
		},

		[JobGetterKeys.volunteerFunctions]: state => state.volunteerFunctions,
		[JobGetterKeys.sessionTypes]: state => state.sessionTypes,
		[JobGetterKeys.loading]: state => Boolean(state.loading),
		[JobGetterKeys.submitting]: state => state.submitting,
		[JobGetterKeys.submitFrom]: state => state.submitFrom,
		[JobGetterKeys.lastError]: state => state.lastError,
		[JobGetterKeys.eventTypes]: state => state.eventTypes,
		[JobGetterKeys.currentJob]: (state): Job | JobDto | null =>
			state.currentJob
				? {
						...state.currentJob,
						// sort sessions
						sessions: state.currentJob?.sessions
							? state.currentJob.sessions
									.sort((s1, s2) => s1.position - s2.position)
									.map(session => ({
										...session,
										// sort timeslots
										timeslots: session.timeslots?.sort((t1, t2) =>
											t1.dateGroupId === t2.dateGroupId
												? t1.position - t2.position
												: t1.dateGroupId - t2.dateGroupId,
										),
										frequency: session.frequency || ScheduleFrequency.oneOff,
									}))
							: undefined,
				  }
				: null,
		[JobGetterKeys.jobStatus]: (state): JobStatusCode | undefined =>
			state.currentJob?.status,
		[JobGetterKeys.currentJobSessions]: (_, getters) =>
			getters[JobGetterKeys.currentJob]?.sessions || [],
		[JobGetterKeys.currentTimeslotInstance]: state =>
			state.currentTimeslotInstance,
		[JobGetterKeys.currentJobValidations]: state => state.currentJobValidations,
		[JobGetterKeys.currentStep]: state => state.currentStep,
		[JobGetterKeys.applicationsPageData]: state => state.applicationsPageData,
		[JobGetterKeys.jobTimeslotPageData]: state => state.jobTimeslotPageData,
		[JobGetterKeys.currentTimeslot]: state => state.currentTimeslot,
		[JobGetterKeys.currentServiceHoursSession]: state =>
			state.currentServiceHoursSession,
		[JobGetterKeys.currentJobHasAgeRequirement]: (state): boolean =>
			Boolean(
				state.currentJob?.volunteerInfo?.minAge ||
					state.currentJob?.volunteerInfo?.maxAge ||
					state.currentJob?.pcAge,
			),
		[JobGetterKeys.currentApplication]: state => state.currentApplication,
		[JobGetterKeys.draftApplication]: state => state.currentDraftApplication,
		[JobGetterKeys.getSessionByPosition]: (_, getters) => (
			sessionPosition: number,
		) =>
			(getters[JobGetterKeys.currentJobSessions] as JobSession[]).find(
				session => session.position === sessionPosition,
			),
		[JobGetterKeys.lastJobList]: state => state.lastJobList,
		[JobGetterKeys.attendanceFullList]: state => state.attendanceFullList,
		[JobGetterKeys.getAttendanceOfflineFullListByTimeslotInstance]: state => (
			timeslotInstanceId: string,
		): JobAttendance[] =>
			state.attendanceOfflineFullList[timeslotInstanceId] || [],
		[JobGetterKeys.getOfflineAttendanceChangesByTimeslotInstance]: state => (
			timeslotInstanceId: string,
		): JobOfflineAttendanceChange[] =>
			state.groupedOfflineAttendanceChanges[timeslotInstanceId] || [],
		[JobGetterKeys.attendanceImportData]: state =>
			state.attendanceImportData.map(item => ({
				...item,
				// calculate isSelectable
				isSelectable:
					// new contact + new application
					item.isNewContact ||
					// existing contact must be single
					item.matchType === AttendanceImportMatchType.single,
				// more validation for existing application deferred to when the item is selected
			})),
		[JobGetterKeys.applicationCache]: state => state.applicationCache,
	},
};

export default store;
